import React, { useState } from 'react';
import { format, parseISO, startOfMonth, endOfMonth, eachDayOfInterval, isWeekend, isSameDay } from 'date-fns';
import { useShift } from '../context/ShiftContext';
import { useUser } from '../context/UserContext';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const Calendar = () => {
  const {
    shifts,
    holidays
  } = useShift();
  const {
    users
  } = useUser();
  const [currentDate, setCurrentDate] = useState(new Date());
  // Get days for current month
  const firstDayOfMonth = startOfMonth(currentDate);
  const lastDayOfMonth = endOfMonth(currentDate);
  const daysInMonth = eachDayOfInterval({
    start: firstDayOfMonth,
    end: lastDayOfMonth
  });
  // Previous and next month navigation
  const goToPreviousMonth = () => {
    const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1);
    setCurrentDate(previousMonth);
  };
  const goToNextMonth = () => {
    const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1);
    setCurrentDate(nextMonth);
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-300">
      <div className="flex items-center justify-between mb-6" data-id="element-301">
        <h2 className="text-2xl font-bold text-gray-800" data-id="element-302">
          {format(currentDate, 'MMMM yyyy')}
        </h2>
        <div className="flex space-x-2" data-id="element-303">
          <button onClick={goToPreviousMonth} className="p-2 rounded-full hover:bg-gray-100" data-id="element-304">
            <ChevronLeftIcon size={20} data-id="element-305" />
          </button>
          <button onClick={() => setCurrentDate(new Date())} className="px-3 py-1 bg-blue-100 text-blue-700 rounded-md text-sm hover:bg-blue-200" data-id="element-306">
            Today
          </button>
          <button onClick={goToNextMonth} className="p-2 rounded-full hover:bg-gray-100" data-id="element-307">
            <ChevronRightIcon size={20} data-id="element-308" />
          </button>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-309">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-310">
          <thead data-id="element-311">
            <tr data-id="element-312">
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-313">
                Date
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-314">
                Day
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-315">
                Holiday
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-316">
                Night Shift
              </th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-317">
                Weekend Shifts
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-318">
            {daysInMonth.map(day => {
            const dateString = format(day, 'yyyy-MM-dd');
            const holiday = holidays.find(h => h.date === dateString);
            const nightShift = shifts.find(s => s.date === dateString && s.type === 'night');
            const weekendShift = shifts.find(s => s.date === dateString && s.type === 'weekend');
            const isWeekendDay = isWeekend(day);
            const nightShiftUser = nightShift?.assignedTo[0] ? users.find(u => u.id === nightShift.assignedTo[0]) : null;
            const weekendShiftUsers = weekendShift?.assignedTo.map(userId => users.find(u => u.id === userId)).filter(Boolean) || [];
            return <tr key={dateString} className={`${isWeekendDay ? 'bg-gray-50' : ''} ${holiday ? 'bg-red-50' : ''}`} data-id="element-319">
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-320">
                    {format(day, 'MM/dd/yyyy')}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-321">
                    {format(day, 'EEEE')}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-322">
                    {holiday?.name || ''}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-323">
                    {nightShiftUser?.name || ''}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500" data-id="element-324">
                    {isWeekendDay ? <div className="space-y-1" data-id="element-325">
                        {weekendShiftUsers.map((user, index) => <div key={index} data-id="element-326">{user?.name}</div>)}
                        {weekendShiftUsers.length === 0 && ''}
                      </div> : ''}
                  </td>
                </tr>;
          })}
          </tbody>
        </table>
      </div>
    </div>;
};
export default Calendar;